<template>
  <v-btn
    v-permission="permissions"
    class="primary"
    @click="$dialog.show(dialog)"
  >
    {{ buttonText }}
  </v-btn>
</template>

<script>
export default {
  name: 'create-button',
  props: {
    buttonText: {
      type: String,
      default: () => 'Создать',
    },
    permissions: {
      type: Array,
      default: () => [],
    },
    dialog: {
      type: String,
      default: () => '',
    },
  },
};
</script>

<style scoped>

</style>
